import { render, staticRenderFns } from "./ArrowLinkUp.vue?vue&type=template&id=9dca5166&"
import script from "./ArrowLinkUp.vue?vue&type=script&lang=ts&"
export * from "./ArrowLinkUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports